import React, { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import './marketTypes.scss';
import { BitCoins, Certified, DefaultBlot, Diamonds, GraphTable, VerticalMoney } from 'src/assets';
import { useAnimatedView } from 'src/hooks/useAnimatedView';

export const MarketTypes = () => {
  const { t } = useTranslation();

  const ref0 = useRef();
  const ref1 = useRef();
  const ref2 = useRef();
  const ref3 = useRef();
  const ref4 = useRef();
  const ref5 = useRef();

  const { isVisible: isVisible0 } = useAnimatedView(ref0);
  const { isVisible: isVisible1 } = useAnimatedView(ref1);
  const { isVisible: isVisible2 } = useAnimatedView(ref2);
  const { isVisible: isVisible3 } = useAnimatedView(ref3);
  const { isVisible: isVisible4 } = useAnimatedView(ref4);
  const { isVisible: isVisible5 } = useAnimatedView(ref5);

  const options = [
    {
      name: 'stock',
      image: Certified,
      pos: 'left',
      ref: ref1,
      isVisible: isVisible1,
    },
    {
      name: 'indexes',
      image: GraphTable,
      pos: 'right',
      ref: ref2,
      isVisible: isVisible2,
    },
    {
      name: 'forex',
      image: VerticalMoney,
      pos: 'left',
      ref: ref3,
      isVisible: isVisible3,
    },
    {
      name: 'raw',
      image: Diamonds,
      pos: 'right',
      ref: ref4,
      isVisible: isVisible4,
    },
    {
      name: 'crypto',
      image: BitCoins,
      pos: 'left',
      ref: ref5,
      isVisible: isVisible5,
    },
  ];

  const renderMarketItem = useCallback(
    (props) => {
      const { image, name, pos, ref, isVisible } = props;

      return (
        <div
          className={`market-types-item ${pos === 'right' ? 'market-row-reverse' : ''} ${
            isVisible ? 'active-animation' : ''
          }`}
          key={name}
          ref={ref}
        >
          {pos === 'left' && <img src={image} alt={image} className="market-types-item-image" />}
          <div className="market-types-item-content">
            <h2 className="market-types-item-title">{t(`marketTypes:${name}:title`)}</h2>
            <text
              className="market-types-item-subtitle"
              dangerouslySetInnerHTML={{ __html: t(`marketTypes:${name}:subtitle`) }}
            />
          </div>
          {pos === 'right' && <img src={image} alt={image} className="market-types-item-image" />}
        </div>
      );
    },
    [t],
  );

  return (
    <div className="market-types">
      <div className={`market-types-content ${isVisible0 ? 'active-animation' : ''}`} ref={ref0}>
        <div className="market-types-title">
          <supertitle>{t('marketTypes:supertitle')}</supertitle>
          <h1 className="market-types-heading">
            <blue-underline>{t('marketTypes:type')}</blue-underline>{' '}
            <blue-text>{t('marketTypes:market')}</blue-text>
          </h1>
        </div>
        {options?.map((item) => renderMarketItem(item))}

        <img src={DefaultBlot} alt={DefaultBlot} className="market-types-image-1" />
        <img src={DefaultBlot} alt={DefaultBlot} className="market-types-image-2" />
      </div>
    </div>
  );
};
